import { lazy } from "react";
import Login from "../pages/auth/login";
import CasinoComponentTournament from "../components/casino-component_tournament";
import ChatComponent from "../components/chatComponent";
const GameSection = lazy(() => import("../pages/gameSection"));
const CasinoProvider = lazy(() => import("../pages/games/casino-provider"));
const Tournaments = lazy(() => import("../pages/tournaments/tournaments"));
const TournamentsView = lazy(() =>
  import("../pages/tournaments/tournaments-view")
);
const LudoTournaments = lazy(() => import("../pages/tournaments/ludo-tournaments"));
const LudoTournamentView = lazy(() => import("../pages/tournaments/ludo-tournament-view"));
const LudoGame = lazy(() => import("../pages/tournaments/ludo-game"));

const RakebackVipClub = lazy(() =>
  import("../pages/rakeback-vip-club/rakebackVipClub")
);
const ProfileDashboard = lazy(() =>
  import("../pages/profile/profile-dashboard")
);
const Affiliate = lazy(() => import("../pages/affiliate/affiliate"));
const SportsbookCricket = lazy(() => import("../pages/sportsbook/cricket"));
const SportsbookPrematch = lazy(() => import("../pages/sportsbook/prematch"));
const SportsbookEsports = lazy(() => import("../pages/sportsbook/esports"));
const SportsbookAviator = lazy(() => import("../pages/sportsbook/aviator"));
const SportsbookLive = lazy(() => import("../pages/sportsbook/live"));
const SportsGame = lazy(() => import("../pages/sportsbook/games"));
const SportsbookVirtual = lazy(() => import("../pages/sportsbook/virtual"));
const SportsbookRacing = lazy(() => import("../pages/sportsbook/racing"));
const CasinoComponent = lazy(() => import("../components/casino-component"));
const AffiliateSection = lazy(() => import("../pages/affiliate/affiliateMain"));
const NotFound = lazy(() => import("../pages/not-found"));
const HomeScreen = lazy(() => import("../pages/home-screen"));
const EmailVerification = lazy(() =>
  import("../pages/auth/email-verification")
);
const SignUp = lazy(() => import("../pages/auth/signup"));
const ForgotPassword = lazy(() => import("../pages/auth/forgot-password"));
const ResetPassword = lazy(() => import("../pages/auth/reset-password"));
const FormBuilder = lazy(() => import("../pages/form-builder/index"));
const ForgotPwdVerification = lazy(() =>
  import("../pages/auth/forgotpwd-verification")
);
const KycOtp = lazy(() => import("../pages/form-builder/otp-verification"));
const Leaderboard = lazy(() => import("../pages/leaderboard"));
const CasinoSection = lazy(() => import("../pages/casino"));
const Wallet = lazy(() => import("../pages/wallet/index"));
const ProfileDetails = lazy(() => import("../pages/profile/profile-details"));
const PaymentDetails = lazy(() => import("../pages/payment/index"));
const MyBets = lazy(() => import("../pages/bets/my-bets"));
const BetProfitLoss = lazy(() => import("../pages/bets/bet-profit-loss"));
const ReferralEarning = lazy(() => import("../pages/referral-earning"));
const Notification = lazy(() => import("../pages/auth/notification"));
const ProviderGames = lazy(() => import("../pages/games/provider-games"));
const CMS = lazy(() => import("../pages/cms/cms"));
const Bonus = lazy(() => import("../pages/bonus/index"));
const ComingSoon = lazy(() => import("../components/coming-soon"));
const Promotion = lazy(() => import("../pages/promotion"));
const InstantGamePage = lazy(() => import("../pages/instant-game"));
const GameLaunch = lazy(() => import("../pages/games/game-launch"));
const ShareCode = lazy(() => import("../pages/sportsbook/shareCode"));

export const openRoutes = [
  {
    layout: <Login />,
    path: "/signin",
    name: "Login",
    isAuthProtected: false,
  },
  {
    layout: <EmailVerification />,
    path: "/email-verification",
    name: "EmailVerification",
    isAuthProtected: false,
  },
  {
    layout: <SignUp />,
    path: "/signup",
    name: "SignUp",
    isAuthProtected: false,
  },
  {
    layout: <ForgotPassword />,
    path: "/forgot-password",
    name: "ForgotPassword",
    isAuthProtected: false,
  },
  {
    layout: <ResetPassword />,
    path: "/reset-password/:token",
    name: "ResetPassword",
    isAuthProtected: false,
  },
  {
    layout: <FormBuilder />,
    path: "/kyc-verification",
    name: "KYCVerification",
    isAuthProtected: false,
  },

  {
    layout: <KycOtp />,
    path: "/kyc-otp-verification",
    name: "KycOtp",
    isAuthProtected: false,
  },
  {
    layout: <ForgotPwdVerification />,
    path: "/forgot-password-verification",
    name: "ForgotPwdVerification",
    isAuthProtected: false,
  },
  {
    layout: <NotFound />,
    path: "/not-found",
    name: "NotFound",
    isAuthProtected: false,
  },
  {
    layout: <AffiliateSection />,
    path: "/affiliate-section",
    name: "AffiliateSection",
    isAuthProtected: false,
  },
  // {
  //   layout: <Promotion />,
  //   path: "/promotion",
  //   name: "Promotion",
  //   isAuthProtected: false,
  // },
];
export const privateRoutes = [
  {
    layout: <Login />,
    path: "/signin",
    name: "Login",
    isAuthProtected: false,
  },
  {
    layout: <EmailVerification />,
    path: "/email-verification",
    name: "EmailVerification",
    isAuthProtected: false,
  },
  {
    layout: <SignUp />,
    path: "/signup",
    name: "SignUp",
    isAuthProtected: false,
  },
  {
    layout: <HomeScreen />,
    path: "",
    name: "HomeScreen",
    isAuthProtected: false,
  },
  {
    layout: <ReferralEarning />,
    path: "referral-earning",
    name: "ReferralEarning",
    isAuthProtected: true,
  },

  {
    layout: <Notification />,
    path: "notification",
    name: "Notification",
    isAuthProtected: true,
  },
  {
    layout: <Notification />,
    path: "/notifications",
    name: "Notification",
    isAuthProtected: true,
  },
  {
    layout: <ForgotPassword />,
    path: "/forgot-password",
    name: "ForgotPassword",
    isAuthProtected: false,
  },
  {
    layout: <ResetPassword />,
    path: "/reset-password/:token",
    name: "ResetPassword",
    isAuthProtected: false,
  },
  {
    layout: <FormBuilder />,
    path: "/kyc-verification",
    name: "KYCVerification",
    isAuthProtected: false,
  },
  {
    layout: <ForgotPwdVerification />,
    path: "/forgot-password-verification",
    name: "ForgotPwdVerification",
    isAuthProtected: false,
  },
  {
    layout: <KycOtp />,
    path: "/kyc-otp-verification",
    name: "KycOtp",
    isAuthProtected: false,
  },
  {
    layout: <Tournaments />,
    path: "/tournaments",
    name: "Tournaments",
    isAuthProtected: false,
  },
  {
    layout: <LudoTournaments />,
    path: "/ludo-tournaments",
    name: "Ludo Tournaments",
    isAuthProtected: false,
  },
  {
    layout: <LudoTournamentView />,
    path: "/ludo-tournament-view/:id",
    name: "Ludo Tournament View",
    isAuthProtected: false,
  },
  {
    layout: <LudoGame />,
    path: "/ludo-game/:id",
    name: "Ludo Game",
    isAuthProtected: false,
  },




  {
    layout: <TournamentsView />,
    path: "/tournaments/view/:id",
    name: "Tournaments",
    isAuthProtected: false,
  },
  {
    layout: <RakebackVipClub />,
    path: "/rakeback-vip-club",
    name: "rakebackVipClub",
    isAuthProtected: false,
  },
  {
    layout: <Affiliate />,
    path: "/affiliate-referral-earning",
    name: "Affiliate",
    isAuthProtected: false,
  },
  {
    layout: <Leaderboard />,
    path: "leaderboard",
    name: "Leaderboard",
    isAuthProtected: true,
  },
  {
    layout: <NotFound />,
    path: "/not-found",
    name: "NotFound",
    isAuthProtected: false,
  },
  {
    layout: <CasinoSection />,
    path: "/casino",
    name: "CasinoSection",
    isAuthProtected: true,
  },
  {
    layout: <CasinoProvider />,
    path: "/casino-provider",
    name: "CasinoProvider",
    isAuthProtected: true,
  },
  // {
  //   layout: <CasinoGames />,
  //   path: "/casino-games/:category",
  //   name: "CasinoGames",
  //   isAuthProtected: true,
  // },

  {
    layout: <Wallet />,
    path: "/wallet",
    name: "Wallet",
    isAuthProtected: true,
  },
  {
    layout: <Wallet />,
    path: "profile-dashboard/wallet",
    name: "Wallet",
    isAuthProtected: true,
  },
  {
    layout: <ProfileDetails />,
    path: "/profile-details",
    name: "ProfileDetails",
    isAuthProtected: true,
  },

  {
    layout: <ProfileDashboard />,
    path: "/profile-dashboard/:tab?",
    name: "ProfileDashboard",
    isAuthProtected: true,
  },
  {
    layout: <PaymentDetails />,
    path: "/payment-details",
    name: "PaymentDetails",
    isAuthProtected: true,
  },
  {
    layout: <MyBets />,
    path: "/my-bets",
    name: "MyBets",
    isAuthProtected: true,
  },
  {
    layout: <BetProfitLoss />,
    path: "/bet-profit-loss",
    name: "BetProfitLoss",
    isAuthProtected: true,
  },
  {
    layout: <ProviderGames />,
    path: "/provider-games",
    name: "ProviderGames",
    isAuthProtected: true,
  },
  {
    layout: <CMS />,
    path: "/cms/:key",
    name: "CMS",
    isAuthProtected: false,
  },
  {
    layout: <GameSection />,
    path: "/game-section",
    name: "GameSection",
    isAuthProtected: true,
  },

  {
    layout: <AffiliateSection />,
    path: "/affiliate-section",
    name: "AffiliateSection",
    isAuthProtected: false,
  },
  {
    layout: <Bonus />,
    path: "/bonus",
    name: "Bonus",
    isAuthProtected: true,
  },
  {
    layout: <SportsbookCricket />,
    path: "/sportsbook/cricket",
    name: "Cricket",
    isAuthProtected: true,
  },
  {
    layout: <SportsbookPrematch />,
    path: "/sportsbook/prematch",
    name: "Prematch",
    isAuthProtected: true,
  },
  {
    layout: <SportsbookEsports />,
    path: "/sportsbook/esports",
    name: "Esports",
    isAuthProtected: true,
  },
  {
    layout: <SportsbookAviator />,
    path: "/sportsbook/aviator",
    name: "Aviator",
    isAuthProtected: true,
  },
  {
    layout: <SportsbookRacing />,
    path: "/sportsbook/racing",
    name: "Racing",
    isAuthProtected: true,
  },
  {
    layout: <SportsbookVirtual />,
    path: "/sportsbook/virtual",
    name: "Virtual",
    isAuthProtected: true,
  },
  {
    layout: <SportsbookLive />,
    path: "/sportsbook/live",
    name: "Live",
    isAuthProtected: true,
  },
  {
    layout: <SportsGame />,
    path: "/sports-game/:category",
    name: "Live",
    isAuthProtected: true,
  },
  {
    layout: <CasinoComponent />,
    path: "/casino-games/:category",
    name: "Casino Games",
    isAuthProtected: true,
  },
  {
    layout: <CasinoComponent />,
    path: "/live-casino-games/:category",
    name: "Live Casino Games",
    isAuthProtected: true,
  },
  {
    layout: <ComingSoon />,
    path: "/coming-soon",
    name: "Coming Soon",
    isAuthProtected: true,
  },
  {
    layout: <Promotion />,
    path: "/promotion",
    name: "Promotion",
    isAuthProtected: true,
  },
  {
    layout: <InstantGamePage />,
    path: "/instant-game-list",
    name: "Instant Games",
    isAuthProtected: true,
  },
  {
    layout: <GameLaunch />,
    path: "/game-launch",
    name: "Game Launch",
    isAuthProtected: true,
  },
  {
    layout: <CasinoComponentTournament />,
    path: "/casino/:tournamentID",
    name: "Casino",
    isAuthProtected: true,
  },
  {
    layout: <CasinoComponentTournament />,
    path: "/casino-new/:promotionId",
    name: "Casino",
    isAuthProtected: true,
  },
  {
    layout: <ChatComponent />,
    path: "/chat",
    name: "Chat",
    isAuthProtected: true,
  },
  {
    layout: <ShareCode />,
    path: "/sportsbook",
    name: "Sportsbook",
    isAuthProtected: false,
  },
];
